/* jshint esversion: 6 */
import { login,loginVerify, logout, getInfo, changeCompany } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getConst } from '@/api/const'
import { getBaseData } from '@/api/basedata'
import localcache from '@/common/localcache'

const user = {
  state: {
    token: getToken(),
    name: localcache.getStr(localcache.SET_NAME),
    avatar: localcache.getStr(localcache.SET_AVATAR),
    account: localcache.getObj(localcache.SET_ACCOUNT),
    roles: localcache.getArr(localcache.SET_ROLES),
    serverconst: localcache.getObjInData(localcache.CONST_DATA),
    basedata: localcache.getArrInData(localcache.BASE_DATA),
    constMD5: localcache.getStr(localcache.CONST_MD5),
    basedataMD5: localcache.getStr(localcache.BASE_DATA_MD5),
    repairList: localcache.getStr(localcache.REPAIR_LIST)
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = (!name ? '' : name)
      localcache.set(localcache.SET_NAME, state.name)
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = (!avatar ? '' : avatar)
      localcache.set(localcache.SET_AVATAR, state.avatar)
    },
    SET_ACCOUNT: (state, account) => {
      state.account = (!account ? {} : account)
      localcache.set(localcache.SET_ACCOUNT, state.account)
    },
    SET_ROLES: (state, roles) => {
      state.roles = (!roles ? [] : roles)
      localcache.set(localcache.SET_ROLES, state.roles)
    },
    SET_SERVER_CONST: (state, data) => {
      state.serverconst = (!data ? {} : data)
    },
    SET_BASE_DATA: (state, data) => {
      state.basedata = (!data ? [] : data)
    },
    SET_CONST_MD5: (state, data) => {
      state.constMD5 = (!data ? {} : data)
    },
    SET_BASE_DATA_MD5: (state, data) => {
      state.basedataMD5 = (!data ? [] : data)
    },
    REPAIR_LIST: (state, data) =>{
      state.repairList = (!data ? [] : data)
    }
  },
  actions: {
    repairList({ commit },userInfo){
      commit('REPAIR_LIST', userInfo)
    },
    // 登录
    Login({ commit }, userInfo) {
      // const username = userInfo.account.trim()
      return new Promise((resolve, reject) => {
        login(userInfo.account, userInfo.password).then(response => {
          const token = response.data.token
          setToken(token)
          commit('SET_TOKEN', token)
          commit('SET_ROLES', response.data.perms)
          commit('SET_NAME', response.data.account.nickName)
          commit('SET_ACCOUNT', response.data.account)
          commit('SET_AVATAR', response.data.account.avatar)
          commit('SET_CONST_MD5', response.data.constMD5)
          commit('SET_BASE_DATA_MD5', response.data.baseDataMD5)
          resolve()
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    // 验证码登录
    loginVerify({ commit }, loginInfo) {
      const username = loginInfo.username.trim()
      const verifycode = loginInfo.verifycode.trim()
      return new Promise((resolve, reject) => {
        loginVerify(username, verifycode).then(response => {
          const token = response.data.token
          setToken(token)
          commit('SET_TOKEN', token)
          commit('SET_ROLES', response.data.perms)
          commit('SET_NAME', response.data.account.nickName)
          commit('SET_ACCOUNT', response.data.account)
          commit('SET_AVATAR', response.data.account.avatar)
          commit('SET_CONST_MD5', response.data.constMD5)
          commit('SET_BASE_DATA_MD5', response.data.baseDataMD5)
          resolve()
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const token = response.data.token
          setToken(token)
          commit('SET_TOKEN', token)
          commit('SET_ROLES', response.data.perms)
          commit('SET_NAME', response.data.account.nickName)
          commit('SET_ACCOUNT', response.data.account)
          commit('SET_AVATAR', response.data.account.avatar)
          commit('SET_CONST_MD5', response.data.constMD5)
          commit('SET_BASE_DATA_MD5', response.data.baseDataMD5)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 切换公司
    changeCompany({ commit, state }, companyId) {
      return new Promise((resolve, reject) => {
        changeCompany(companyId).then(response => {
          const token = response.data.token
          setToken(token)
          commit('SET_TOKEN', token)
          commit('SET_ROLES', response.data.perms)
          commit('SET_NAME', response.data.account.nickName)
          commit('SET_ACCOUNT', response.data.account)
          commit('SET_AVATAR', response.data.account.avatar)
          commit('SET_CONST_MD5', response.data.constMD5)
          commit('SET_BASE_DATA_MD5', response.data.baseDataMD5)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_ACCOUNT', {})
          removeToken()
          localcache.remove(localcache.SET_NAME)
          localcache.remove(localcache.SET_AVATAR)
          localcache.remove(localcache.SET_ACCOUNT)
          localcache.remove(localcache.SET_ROLES)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        localcache.remove(localcache.SET_NAME)
        localcache.remove(localcache.SET_AVATAR)
        localcache.remove(localcache.SET_ACCOUNT)
        localcache.remove(localcache.SET_ROLES)
        resolve()
      })
    },
    // 加载基础数据
    loadBaseData({ commit }) {
      let md5 = 0
      const cacheData = localcache.get(localcache.BASE_DATA)
      if (cacheData) {
        md5 = cacheData.MD5
      }
      return new Promise((resolve, reject) => {
        getBaseData(md5).then(response => {
          if (response.data === 'NO_UPDATE') {
          } else {
            localcache.set(localcache.BASE_DATA, response.data)
            commit('SET_BASE_DATA', response.data.data)
          }
          resolve()
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    // 加载静态常量
    loadConst({ commit }) {
      let md5 = 0
      const cacheData = localcache.get(localcache.CONST_DATA)
      if (cacheData) {
        md5 = cacheData.MD5
      }
      return new Promise((resolve, reject) => {
        getConst(md5).then(response => {
          if (response.data === 'NO_UPDATE') {
          } else {
            localcache.set(localcache.CONST_DATA, response.data)
            commit('SET_SERVER_CONST', response.data.data)
          }
          resolve()
        }).catch(error => {
          console.dir(error)
          reject(error)
        })
      })
    },
    // 更改token
    ChangeToken({ commit }, token) {
      const oldToken = getToken()
      setToken(token)
      commit('SET_TOKEN', token)
      return new Promise((resolve, reject) => {
        if (oldToken === token) {
          resolve()
          return
        }
        getInfo(token).then(response => {
          commit('SET_ROLES', response.data.perms)
          commit('SET_NAME', response.data.account.nickName)
          commit('SET_ACCOUNT', response.data.account)
          commit('SET_AVATAR', response.data.account.avatar)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js